/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReqLogin } from 'src/types/auth';

import axiosInstance from './instance';

interface LoginData {
  username: string;
  password: string;
}

interface RegisterData {
  username: string;
  email: string;
  password: string;
}

const authApi = {
  // 유저 인증 로직
  //
  validToken() {
    return axiosInstance.get('/auth/valid');
  },

  // 로그인(login)
  // https://dev.clp.kr/anchor/api/static/docs/front/account.html#resources-account-sign-in-password-and-social
  login(params: ReqLogin) {
    return axiosInstance.post('/auth/login', params);
  },

  // 로그 아웃(logout)
  // https://dev.clp.kr/spc/api/static/docs/front/account.html#resources-account-sign-out
  logout() {
    return axiosInstance.put('/auth/logout');
  },
};

export default authApi;
